import { render, staticRenderFns } from "./RightMenu.vue?vue&type=template&id=11c97d94&scoped=true"
import script from "./RightMenu.vue?vue&type=script&lang=js"
export * from "./RightMenu.vue?vue&type=script&lang=js"
import style0 from "./RightMenu.vue?vue&type=style&index=0&id=11c97d94&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c97d94",
  null
  
)

export default component.exports